/* This file is autogenerated, see readme.md for instructions */
import OutOfStockSvgIcon from '@bloomreach/banana-theme/icons/out-of-stock.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const OutOfStockIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <OutOfStockSvgIcon />
    </Icon>
  );
});

OutOfStockIcon.displayName = 'OutOfStockIcon';

export default OutOfStockIcon;
